import axios from "axios";
import { getParentUnlock, clearParentUnlock } from "@/lib/parentUnlock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const unlock = getParentUnlock();
  if (unlock) config.headers["X-Parent-Unlock"] = unlock;
  return config;
});

// If the account gets blocked mid-session, sign out and show a clear notice.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && detail === "Parent PIN required" && window.location.pathname.startsWith("/parent")) {
      clearParentUnlock();
      window.location.reload();
    }
    // another account logged in on this browser (e.g. a test parent): the admin page must not silently show empty data
    if (err?.response?.status === 403 && detail === "Admins only" && window.location.pathname.startsWith("/admin")) {
      try { localStorage.setItem("bb_blocked_msg", "Your admin session was replaced by another login on this browser. Please log in again with the admin account."); localStorage.removeItem("bb_token"); } catch { /* ignore */ }
      window.location.href = "/login";
    }
    if (err?.response?.status === 403 && typeof detail === "string" && detail.includes("contact your administrator")) {
      try {
        localStorage.setItem("bb_blocked_msg", detail);
        localStorage.removeItem("bb_token");
      } catch { /* ignore */ }
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
export default api;
